<template>
<div class="JZJL">
  <div class="boxs"  ref='jzjls' @scroll="handleScroll">
    <div v-for="item in list">
      <div class="box-content" v-if="item.type == 'cc'">
        <div style="display: flex;align-items: flex-start">
          <p class="cz"><span>初</span></p>
          <div class="wzxx">
            <p>就诊门店：{{item.SimpleShop.ShopName?item.SimpleShop.ShopName:'无'}}</p>
            <p>咨询编号：{{item.bh}}</p>
            <p>创建时间：{{item.ChooseAddTime}}</p>
            <p>专<span style="padding-left: 2em"></span>家：{{item.SimpleExpert.ExpertName}}</p>
            <div class="hzbq">
              <p v-for="items in item.ListChooseStep">{{items}}</p>
            </div>
          </div>
<!--          <div v-if="item.iswc == 'sgsqm'" class="iswc">视光师签名</div>-->
<!--          <div v-if="item.iswc == 'ysqm'" class="iswc">医生签名</div>-->
        </div>
        <div class="wxfn">
          <p @click="ckbg(item.ChooseId)">查看报告</p>
          <p @click="gos(item.ChooseId, item.ChooseSignPath, item.ChooseOptometristSignPath, item)">进入诊疗</p>
          <p style="margin: 0" @click="addfz(item.ChooseId)">+添加复诊</p>
        </div>
      </div>
      <div class="box-content" v-if="item.type == 'fc'">
        <div style="display: flex;align-items: flex-start">
          <p class="fc"><span>复</span></p>
          <div class="wzxx">
            <p>就诊门店：{{item.SimpleShop.ShopName?item.SimpleShop.ShopName:'无'}}</p>
            <p>咨询编号：{{item.ChooseId.slice(0,8).toUpperCase()}}</p>
            <p>创建时间：{{item.ChooseAddTime}}</p>
            <p>专<span style="padding-left: 2em"></span>家：{{item.SimpleExpert.ExpertName}}</p>
            <div class="hzbq">
              <p v-for="items in item.ListChooseStep">{{items}}</p>
            </div>
          </div>
<!--          <div v-if="item.iswc == 'sgsqm'" class="iswc">视光师签名</div>-->
<!--          <div v-if="item.iswc == 'ysqm'" class="iswc">医生签名</div>-->
        </div>
        <div class="wxfn">
          <p @click="ckbg(item.ChooseId)">查看报告</p>
          <p  @click.stop="gos(item.ChooseId,'','', item)">进入诊疗</p>
          <!--      <p style="margin: 0">+添加复诊</p>-->
        </div>
      </div>
    </div>
  </div>

  <div style="padding-top: 10px;">
    <el-button type="primary" @click="xjcz">新建初诊</el-button>
  </div>

  <el-dialog
      title="报告详情"
      :visible.sync="showyy"
      width="80%"
  >
    <iframe class="znr" ref="prints" :src="src"></iframe>
  </el-dialog>
</div>
</template>

<script>
import pf from "@/publicFn/baseFn"
export default {
  name: "JZJL",
  data() {
    return {
      list: [],
      fy: 50,
      src: '',
      showyy: false
    }
  },
  watch: {
    '$store.state.users.CsUser':function (n, o)  {
      console.log(n)
      if (n) {
        this.fy = 50
        this.getData()
      }else {
        this.list = []
      }
    }
  },
  created() {
    if (this.$store.state.users.CsUser) {
      this.getData()
    }
  },
  methods: {
    gos(id, url, sgurl, item) {
      if (url) {
        this.$store.commit('physicianVisits/upIsqm', false)
      }
      if (sgurl) {
        this.$store.commit('physicianVisits/upissgqm', false)
      }
      pf.clCsData()


      this.$store.commit('physicianVisits/upXzConsulting', id)
      this.$store.commit('physicianVisits/upJump', 1)
      this.$store.commit('users/upCsObj', JSON.parse(JSON.stringify(item)))
      this.$router.push({path: '/'})

    },
    addfz(id) {
      if (!this.$store.state.users.employees) {
        this.$alert("专家未登录，请先登录", "提示")
            .then(res => {
              this.$router.push({
                path: '/employeesLanding',
                query: {types: 1001}
              })
            })
        return
      }
      this._api.physicianVisits.addNewChoose(id)
          .then(res => {
            if (res.msg != 'Success') {
              this.$alert(res.msg, '提示')
              return
            }
            if (res.InsertResult) {
              // this.sx = true
              pf.clCsData()
              this.$store.commit('physicianVisits/upXzConsulting',  res.InsertResult.Choose.ChooseId)
              this.$store.commit('users/upCsObj', JSON.parse(JSON.stringify(res.InsertResult.Choose)))
              this.$store.commit('physicianVisits/upJump', 1)
              pf.initTime()
              this.$router.push({path: '/'})
            }
          })
    },
    getData() {
      let loadingInstance = this.$loading({
        background: 'rgba(0, 0, 0, 0.7)',
        text: '加载中...'
      })
      this._api.userCurdApi.getCsConsulting(this.fy)
          .then(res => {
            // console.log(res)
            loadingInstance.close();
            let fcObj = {}
            if (res.GetListWithBusinessResult && res.GetListWithBusinessResult.length > 0) {
              // let time = res.GetListWithBusinessResult[0].ChooseAddTime.split(' ')[0]
              // time = time.replace(/\//g, '-')
              // time==getTimeNo(0)?this.sj = 1:this.sj = 0
              this.fy = this.fy + 50
              this.list = res.GetListWithBusinessResult.map((item, idx) => {
                if (item.ChooseStep) {
                  if (item.ChooseStep.indexOf('CL_RE_FC') > -1) {
                    item.ListChooseStep.length ? item.ListChooseStep.push('眼底相机') : item.ListChooseStep = ['眼底相机']
                  }
                }
                if (item.ChooseStep) {
                  if (item.ChooseStep.indexOf('CL_RE_OCT') > -1) {
                    item.ListChooseStep.length ? item.ListChooseStep.push('OCT') : item.ListChooseStep = ['OCT']
                  }
                }
                if (item.ChooseStep) {
                  if (item.ChooseStep.indexOf('DoctorSign') > -1) {
                    item.iswc = 'ysqm'
                  }
                  if (item.ChooseStep.indexOf('OptometristSign') > -1) {
                    item.iswc = 'sgsqm'
                  }
                }
                if (item.ChooseParentId == "00000000-0000-0000-0000-000000000000") {
                  item.type = 'cc'
                }
                if (item.ListSonChoose && item.ListSonChoose.length) {
                  fcObj[idx] = [...item.ListSonChoose]
                }
                if (!item.SimpleShop) {
                  item.SimpleShop = {
                    ShopName: '无'
                  }
                }
                if (!item.SimpleUser) {
                  item.SimpleUser = {
                    UserFullName: '无'
                  }
                }
                if (!item.SimpleExpert) {
                  item.SimpleExpert = {
                    ExpertName: '无'
                  }
                }
                item.bh = item.ChooseId.slice(0,8).toUpperCase()
                return item
              })
              for (let key in fcObj) {
                for (let i = 0; i < fcObj[key].length; i++) {
                  fcObj[key][i].type = 'fc'
                  if (!fcObj[key][i].SimpleExpert) {
                    fcObj[key][i].SimpleExpert = {
                      ExpertName: '无'
                    }
                  }
                  if (fcObj[key].ChooseStep) {
                    if (fcObj[key].ChooseStep.indexOf('DoctorSign') > -1) {
                      fcObj[key].iswc = 'ysqm'
                    }
                    if (fcObj[key].ChooseStep.indexOf('OptometristSign') > -1) {
                      fcObj[key].iswc = 'sgsqm'
                    }
                  }
                }
                this.list.splice(Number(key), 0, ...fcObj[key])
              }
            }else {
              this.list = []
            }
          })
          .catch(err => {
            loadingInstance.close();
          })
    },
    ckbg(id) {
      let CustomerId = this.$store.state.users.CsUser.CustomerId
      this.src = `https://c.visumall.com/report/customer/inquirydetailReport.aspx?CustomerId=${CustomerId}&ChooseId=${id}`
      // this.src = this._getUrl('ChooseReport_MR') + `CustomerId=${this.$store.state.users.CsUser.CustomerId}&ChooseId=${id}&ExpertId=${exid}`
      this.showyy = true
    },
    xjcz() {
      if (!this.$store.state.users.employees) {
        this.$alert("专家未登录，请先登录", "提示")
            .then(res => {
              this.$router.push({
                path: '/employeesLanding',
                query: {types: 1001}
              })
            })
        return
      }
      let loadingInstance = this.$loading({
        background: 'rgba(0, 0, 0, 0.7)',
        text: '加载中...'
      })
      this._api.physicianVisits.addNewChoose()
          .then(res => {
            loadingInstance.close()
            if (res.InsertResult) {
              pf.clCsData()
              this.$store.commit('physicianVisits/upIsqm', true)
              this.$store.commit('physicianVisits/upissgqm', true)
              this.$store.commit('physicianVisits/upXzConsulting',  res.InsertResult.Choose.ChooseId)
              this.$store.commit('physicianVisits/upJump', 1)
              this.$store.commit('users/upCsObj', JSON.parse(JSON.stringify(res.InsertResult.Choose)))
              this.$router.push({path: '/'})
            }
          })
    },
    handleScroll() {
      const el = this.$refs.jzjls;
      if (el.scrollHeight - el.scrollTop <= el.clientHeight + 1) {
        this.getData();
      }
    }
  }
}
</script>

<style scoped lang="scss">
.boxs {
  height: calc(100vh - 265px);
  overflow-y: auto;
}
.box-content {
  border-radius: 10px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.15);
  display: flex;
  margin-bottom: 15px;
  padding: 10px 0;
  align-items: flex-start;
  justify-content: space-between;
  position: relative;
}
.cz {
  padding: 2px;
  border-radius: 5px;
  border: 1px solid #1d35a1;
  margin-left: 17px;
  span {
    display: block;
    border-radius: 5px;
    border: 1px solid #1d35a1;
    padding: 0 3px;
    font-size: 15px;
    font-weight: 400;
    color: #1d35a1;
  }
}
.fc {
  padding: 2px;
  border-radius: 14px;
  border: 1px solid rgba(153, 153, 153, 1);
  margin-left: 17px;
  span {
    display: block;
    border-radius: 11px;
    border: 1px solid rgba(153, 153, 153, 1);
    padding: 0 3px;
    font-size: 15px;
    font-weight: 400;
    color: rgba(153, 153, 153, 1);
  }
}

.hzbq {
  width: calc(100vw - 520px);
  display: flex;
  flex-wrap: wrap;
  padding-top: 10px;
  p {
    height: 24px !important;
    padding: 0 5px !important;
    border: 1px solid #1d35a1;
    background: #FFFFFF;
    color: #1d35a1;
    border-radius: 5px;
    margin-right: 10px;
    font-size: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 5px;
  }
}

.wzxx {
  font-size: 15px;
  font-weight: 400;
  color: rgba(105, 105, 105, 1);
  text-align: left;
  padding-left: 20px;
  position: relative;
  p{padding-bottom: 8px}
  p:nth-child(4){padding: 0;}
  @media (max-width: 768px) {
    font-size: 12px;
    width: calc(100vw - 430px);
  }
}
.wxfn {
  position: relative;
  top: -6px;
  padding-right: 25px;
  @media (max-width: 768px) {
    padding-right: 15px;
  }
  p {
    width: 95px;
    border-radius: 5px;
    font-size: 15px;
    font-weight: 400;
    color: rgba(168, 168, 168, 1);
    border: 1px solid rgba(168, 168, 168, 1);
    padding: 5px 0;
    margin-bottom: 12px;
    cursor: pointer;
    @media (max-width: 768px) {
      font-size: 12px;
      width: 80px;
    }
  }
  p:nth-child(2) {
    color: #1d35a1;
    border: 1px solid #1d35a1;
  }
}

.znr {
  width: 100%;
  height: 70vh;
  overflow-y: auto;
}

.iswc {
  position: absolute;
  top: 10px;
  left: 40vw;
  font-size: 16px;
  color: #7f7e7e;
  width: 6em;
  height: 6em;
  border-radius: 50%;
  border: 1px solid #7f7e7e;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
